import { z } from 'zod/v4';

export const copilotOnroadEventAlertSchema = z.object({
  alertId: z.number().min(1),
  alert: z.string(),
  alertName: z.string(),
});

export type CopilotOnroadEventAlert = z.infer<
  typeof copilotOnroadEventAlertSchema
>;
